import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FADE_IN_TOP_BIG } from '../../animations/fade-in.animation';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 's18-play-video-dialog',
  templateUrl: './play-video-dialog.component.html',
  styleUrls: ['./play-video-dialog.component.scss'],
  animations: [FADE_IN_TOP_BIG]
})
export class PlayVideoDialogComponent implements OnInit {
  @ViewChild('videoPlayer', { static: true }) videoplayer: any;
  showAction: boolean = false;
  videoFileName: string;

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PlayVideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.videoFileName = data.videoFileName;
  }

  ngOnInit() {
    this.videoplayer.nativeElement.play();
  }

  videoEnded() {
    this.showAction = true;
  }

  getVideoFileName() {
    return "/assets/videos/" + this.videoFileName;
  }

  slideInActionPanel() {
    if (this.showAction) {
      return 'on';
    }
    return 'off';
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  replayVideo() {
    this.showAction = false;
    this.videoplayer.nativeElement.play();
  }

}
